import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import RoleRequire from "../../helpers/auth/RoleRequire";
import { useAppStore } from "../../stores/RootStore";

import { ColumnDef } from "@tanstack/react-table";
import { useRefreshPersons } from "../../hooks/useRefreshStateHooks/useRefreshPersons";
import { StaffTableData } from "../../types/formDataTypes";
import { Button } from "../../ui/Button";
import { MenuDataTable } from "../../ui/DataTable/MenuDataTable";
import { Input } from "../../ui/Input/Input";
import StaffFilters from "./StaffFilters";



type FilterType = {
    posts: Array<string>;
    divisions: Array<string>;
    statuses: Array<string>;
  };
  
  type CategoriesType = {
    unique_posts_name: Array<string>;
    unique_divisions_name: Array<string>;
    unique_statuses: Array<string>;
  };
    

export default function StaffGrid({onClose}:{onClose: () => void}) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [selected, setSelected] =  useState<StaffTableData>();
    const [search, setSearch] = useState("");
    const [filter, setFilter] = useState<FilterType>({
      posts: [],
      divisions: [],
      statuses: [],
    });
  
    // Получение данных и обновление их в сторе.
    const updateItems = useRefreshPersons();
    useEffect(() => {
      updateItems();
    }, []);
  
    const persons = useAppStore((state) => state.persons);
  
    let nodes = persons?.map((person) => {
      return {
        id: person.id,
        first_name: person.attributes.first_name,
        middle_name: person.attributes.middle_name,
        last_name: person.attributes.last_name,
        post_name: person.attributes.post_name,
        division_name: person.attributes.division_name,
        access_token_id: person.attributes.access_token_id,
        status: person.attributes.status,
        leader: person.attributes.leader,
      };
    });
  
    const categories: CategoriesType = {
      unique_posts_name: [],
      unique_divisions_name: [],
      unique_statuses: [],
    };
  
    // Создание массивов с уникальными названиями для категорий фильтра
    if (nodes) {
      for (let i = 0; i < nodes.length; i++) {
        const elem = nodes[i];
        if (!categories.unique_posts_name.includes(elem.post_name)) categories.unique_posts_name.push(elem.post_name);
        if (!categories.unique_divisions_name.includes(elem.division_name))
          categories.unique_divisions_name.push(elem.division_name);
        if (!categories.unique_statuses.includes(elem.status)) categories.unique_statuses.push(elem.status);
      }
    }
  
    // Сортировка по умолчанию
    //nodes = _.sortBy(nodes, ["inventory_number"]);
  
    nodes = _.sortBy(nodes, []);
    let data = { nodes };
  
    const handleSearch = (event: any) => {
      setSearch(event.target.value);
    };
  
    // Фильтрация через поиск
    data = {
      nodes: data.nodes?.filter(
        (item) =>
          item.last_name.toLowerCase().includes(search.toLowerCase()) ||
          item.access_token_id?.toLowerCase().includes(search.toLowerCase())
      ),
    };
  
    // Фильтрация через категории
    data = {
      nodes: data.nodes?.filter(
        (item) =>
          (filter.posts.length > 0 ? filter.posts.includes(item.post_name) : true) &&
          (filter.divisions.length > 0 ? filter.divisions.includes(item.division_name) : true) &&
          (filter.statuses.length > 0 ? filter.statuses.includes(item.status) : true)
      ),
    };
  
    const columns: ColumnDef<StaffTableData>[] = [
      {
        header: t("initials"),
        size: 1000,
        cell: ({ row }) => (
          <div>
            <div>
              {row.original.middle_name
                ? `${row.original.last_name} ${row.original.first_name} ${row.original.middle_name} `
                : `${row.original.last_name} ${row.original.first_name}`}
            </div>
            <div>{row.original.division_name ? row.original.division_name : "..."} / {row.original.post_name ? row.original.post_name : "..."}</div>
          </div>
        ),
      },
      {
        header: t("status"),
        size: 100,
        minSize: 100,
        maxSize: 100,
        cell: ({ row }) => <div>{row.original.status ? t("staff_" + row.original.status) : ""}</div>,
      },
      {
        header: t("card"),
        size: 100,
        minSize: 100,
        maxSize: 100,
        cell: ({ row }) => <div>{row.original.access_token_id ? row.original.access_token_id : ""}</div>,
      }
    ];
  
    function selectPerson(person: any) {
      navigate(`/data/staff/${person.id}`)
      onClose()
    }
  
    function addPerson() {
      navigate("/data/staff/new")
      onClose()
    }
  

  return (
    <>
        <div className="flex flex-col">
            <div className="flex flex-row w-full h-14 items-center gap-4 px-6 justify-between">
                <Input 
                className="h-8"
                placeholder={t("equipment_search")}
                onChange={handleSearch}
                value={search}
                autoComplete="off"
                width="100%" 
                />
            
            <RoleRequire role="maintainer">
              <Button variant={"default"} size={"md"} onClick={() => addPerson()}>{t("add")}</Button>
            </RoleRequire>
          </div>
          <StaffFilters filterState={[filter, setFilter]} categories={categories} />
        </div>
        
        {!data.nodes?.length ? ( // Заглушка для отсутствия данных при поиске
          <div className="flex w-full h-full justify-center items-center">
            {t("no_data")}
          </div>
        ) : (
          <MenuDataTable route="/data/staff" data={data.nodes} columns={columns} onClickRow={selectPerson} />
        )}
  </>
  )
} 
